<template>
  <div class="content-container">
    <search-comp :search-show="true" @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái khách sạn</div>
                <CalendarSelect
                  v-model="searchParams.date"
                  style="display: block"
                  mode="date"
                />
                <!-- <SingleCalendar
                  v-model="searchParams.date"
                  :min-max="minMax"
                  class="use-icon"
                  :date-data="searchParams.date"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="das-layout">
        <div class="l-w-33 column">
          <div class="section-box outline">
            <div>
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="main-title">{{
                      $t('views.houseKeeper.operation')
                    }}</span>
                  </div>
                </div>
                <hr />
                <div v-loading="loading" class="grid-scroll mt-10">
                  <GridVx
                    ref="agGrid"
                    :auto-size-cell="true"
                    :auto-select-first-row="false"
                    :suppress-row-click-selection="true"
                    :columns="operationCols"
                    :rows="operationRows"
                    class="agGrid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-w-33 column">
          <div class="section-box outline">
            <div>
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="main-title">{{
                      $t('views.houseKeeper.roomTotal')
                    }}</span>
                  </div>
                </div>
                <hr />
                <div v-loading="loading" class="grid-scroll mt-10">
                  <GridVx
                    ref="agGrid"
                    :auto-size-cell="true"
                    :auto-select-first-row="false"
                    :suppress-row-click-selection="true"
                    :columns="totalRoomCols"
                    :rows="totalPhisicalRows"
                    class="agGrid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="section-box outline m-0">
            <div>
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="main-title">{{
                      $t('views.houseKeeper.roomCleanStatus')
                    }}</span>
                  </div>
                </div>
                <hr />
                <div v-loading="loading" class="grid-scroll mt-10">
                  <GridVx
                    ref="agGrid"
                    :auto-size-cell="true"
                    :auto-select-first-row="false"
                    :suppress-row-click-selection="true"
                    :columns="houseKeepingCols"
                    :rows="houseKeepingRows"
                    class="agGrid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-w-33 column">
          <div class="section-box outline">
            <div>
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="main-title">{{
                      $t('views.houseKeeper.diff')
                    }}</span>
                  </div>
                </div>
                <hr />
                <div v-loading="loading" class="grid-scroll">
                  <GridVx
                    ref="agGrid"
                    :auto-size-cell="true"
                    :auto-select-first-row="false"
                    :suppress-row-click-selection="true"
                    :columns="diffCols"
                    :rows="diffStatusRows"
                    class="agGrid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="section-box outline m-0">
            <div>
              <div class="das-form-container">
                <div class="das-form-title-container justify-space-between">
                  <div class="das-form-title">
                    <span class="main-title">{{
                      $t('views.houseKeeper.endDayReference')
                    }}</span>
                  </div>
                </div>
                <hr />
                <div v-loading="loading" class="grid-scroll mt-10">
                  <GridVx
                    ref="agGrid4"
                    :auto-size-cell="false"
                    :auto-select-first-row="false"
                    :suppress-row-click-selection="true"
                    :columns="endOfDayCols"
                    :rows="endOfDayRows"
                    :context="context"
                    class="agGrid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Đối chiếu cuối ngày"
      :visible.sync="dialogVisible4"
      :close-on-click-modal="false"
      width="900px"
    >
      <div v-loading="loading" class="grid-scroll">
        <GridVx
          ref="agGrid4"
          :auto-size-cell="true"
          :auto-select-first-row="false"
          :suppress-row-click-selection="true"
          :columns="endOfDayCols"
          :rows="endOfDayRows"
          :context="context"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogVisible4 = false">
            Đóng
          </button>
          <button class="btn primary small outline">Xem chi tiết</button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getHotelStatus } from '@/api/houseKeeper/hotel-status'
import { CellRenderOpenDialogWhenCLicked } from '@/utils/cellRenders'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
export default {
  components: {
    // SingleCalendar,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderOpenDialogWhenCLicked
  },
  data() {
    return {
      dialogVisible4: false,
      context: null,
      minMax: {
        // min: new Date()
      },
      loading: false,
      searchParams: {
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      },
      time1: new Date(),
      dialogVisible1: false,
      operationCols: [
        {
          headerName: 'Loại phòng',
          field: 'status',
          width: 250
        },
        {
          headerName: 'Phòng',
          field: 'o_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 80
        },
        {
          headerName: 'Người',
          field: 'v_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 80
        }
      ],
      totalRoomCols: [
        {
          headerName: 'Loại phòng',
          field: 'status',
          width: 250
        },
        {
          headerName: 'Số lượng',
          field: 'o_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        }
      ],
      diffCols: [
        {
          headerName: 'Loại sai lệch',
          field: 'status',
          width: 250
        },
        {
          headerName: 'Số lượng',
          field: 'o_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        }
      ],
      houseKeepingCols: [
        {
          headerName: 'Loại phòng',
          field: 'status'
        },
        {
          headerName: 'Có khách',
          field: 'o_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        },
        {
          headerName: 'Trống',
          field: 'v_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        }
      ],
      endOfDayCols: [
        {
          headerName: 'Loại phòng',
          field: 'status',
          width: 250
        },
        {
          headerName: 'Phòng',
          field: 'o_quantity',
          maxWidth: 100,
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: {
            refName: 'agGrid4'
          }
        },
        {
          headerName: 'Người',
          field: 'v_quantity',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100,
          cellRenderer: 'CellRenderOpenDialogWhenCLicked',
          cellRendererParams: {
            refName: 'agGrid4'
          }
        },
        {
          headerName: 'Công suất',
          field: 'performance',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        }
      ],
      endOfDayRows: [],
      diffStatusRows: [],
      totalPhisicalRows: [],
      houseKeepingRows: [],
      operationRows: []
    }
  },
  watch: {
    'searchParams.date'(value) {
      this.attachData()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onReset() {
      this.searchParams.date = this.$moment(new Date()).format('YYYY-MM-DD')
      this.attachData()
    },
    opendialogByCellRenderComp(gridName, colName, rowIdx) {
      switch (gridName) {
        case 'agGrid4':
          this.dialogVisible4 = true
          break
        default:
          break
      }
    },
    onDelete() {
      this.$vxConfirm('Bạn có chắc chắn muốn xóa yêu cầu không', () => {})
    },
    async attachData() {
      this.loading = true
      const data = await getHotelStatus(this.searchParams)
      // console.log('data1', data)
      this.operationRows = data.map.action.map(item => {
        return {
          ...item,
          status: this.$t(`grid.row.${item.status}`)
        }
      })
      this.endOfDayRows = data.map.end_of_day.map(item => {
        return {
          ...item,
          status: this.$t(`grid.row.${item.status}`)
        }
      })
      this.diffStatusRows = data.map.diff_status.map(item => {
        return {
          ...item,
          status: this.$t(`grid.row.${item.status}`)
        }
      })
      this.totalPhisicalRows = data.map.total_physical_room.map(item => {
        return {
          ...item,
          status: this.$t(`grid.row.${item.status}`)
        }
      })
      this.houseKeepingRows = data.map.housekeeping_status.map(item => {
        return {
          ...item,
          status: this.$t(`grid.row.${item.status}`)
        }
      })
      this.loading = false
      // this.ho
    }
    // showFunction() {
    //   this.$router.push('/group/group_master_functions')
    // }
  }
}
</script>

<style lang="scss"></style>
